import React from "react";
import { Create, translate } from "react-admin";
import LineForm from "./LineForm";

const LineFormTitle = ({ translate }) => {
  return <span>{`สร้าง${translate("line.line")}`}</span>;
};
const Title = translate(LineFormTitle);

export const LineCreate = props => (
  <Create title={<Title />} {...props}>
    <LineForm />
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/line/LineCreate.js